exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dup-deliverable-detail[data-v-1ec7df72]{padding:20px;background-color:#fff}.dup-deliverable-detail .dup-preview-description[data-v-1ec7df72]{max-height:300px;overflow-y:auto;padding:8px;border:1px solid #eee;border-radius:4px;background:#fafafa}.edit-deliverable-modal .deliverable-title[data-v-1ec7df72]{font-size:30px;color:#2d2d2d;font-weight:600;line-height:1em}", ""]);

// exports
